import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { OrdersApiAdapter } from '../adapters';

export const useOrderById = (
  barcode: string | null,
  courierId: number | null,
  attempt: number = 0
) => {
  const ordersAdapter = new OrdersApiAdapter(createHttpClient(apiClientWH));

  return useQuery({
    queryKey: ['order', barcode, courierId, attempt],
    queryFn: () => ordersAdapter.identifyOrder(barcode!, courierId!),
    enabled: !!barcode && !!courierId,
    staleTime: 0, // Siempre considerar datos obsoletos para forzar refetch
    gcTime: 10 * 60 * 1000, // 10 minutos
    retry: false, // No reintentar en caso de error
  });
};
